
import { ReactNode } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

type WellnessCardProps = {
  title: string;
  icon: ReactNode;
  children: ReactNode;
  category: "nutrition" | "supplements" | "fitness" | "mindfulness" | "sleep" | "notes" | "overall" | "exercise";
};

export function WellnessCard({ title, icon, children, category }: WellnessCardProps) {
  const getCategoryColor = (category: string) => {
    switch (category) {
      case "nutrition":
        return "from-green-500/20 to-green-500/5 border-green-500/20";
      case "supplements":
        return "from-purple-500/20 to-purple-500/5 border-purple-500/20";
      case "fitness":
      case "exercise":
        return "from-orange-500/20 to-orange-500/5 border-orange-500/20";
      case "mindfulness":
        return "from-blue-500/20 to-blue-500/5 border-blue-500/20";
      case "sleep":
        return "from-indigo-500/20 to-indigo-500/5 border-indigo-500/20";
      case "notes":
        return "from-yellow-500/20 to-yellow-500/5 border-yellow-500/20";
      case "overall":
        return "from-primary/20 to-primary/5 border-primary/20";
      default:
        return "from-gray-500/20 to-gray-500/5 border-gray-500/20";
    }
  };

  return (
    <Card className={`overflow-hidden bg-gradient-to-br ${getCategoryColor(category)} border`}>
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2">
          {icon}
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>{children}</CardContent>
    </Card>
  );
}
